module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/babel-loader/lib/index.js!./UserForm.js"));
	}, "admin");
}


//////////////////
// WEBPACK FOOTER
// ./src/features/users/components/UserForm.js
// module id = 2000
// module chunks = 4